import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import withRouter from '../../../../hoc/with-router';
import { useNotFound } from '../../../../hooks/useNotFound';
import { useGetCommunity } from '../../../../redux/api/communitiesApi';
import { mapCommunitySubscriberRelationsToUsers } from '../../../../utils/collections/map-community-subscribers';
import { useStyles } from './CommunitySubscribers.styles';

function CommunitySubscribers(props) {
  const { params } = props;
  const { t } = useTranslation();
  const {
    data: community,
    isFetching,
    isError,
    error: communityError,
    refetch,
  } = useGetCommunity(params.communityId);
  const pageDataOwners = useMemo(
    () => ({
      community: community ?? null,
    }),
    [community],
  );
  const subscribers =
    pageDataOwners.community === undefined
      ? undefined
      : mapCommunitySubscriberRelationsToUsers(
          pageDataOwners.community.subscribers,
        );
  const theme = useTheme();
  const { classes } = useStyles(theme);
  useNotFound(!isFetching && !community);

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: communityError ? [communityError] : [],
    isLoading: isFetching && pageDataOwners.community === undefined,
    hasData: Boolean(pageDataOwners.community),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('communities.communitySubscribers')}
      backButton
      onRefresh={() => void refetch()}>
      <div className={classes.subscriptionsWrapper}>
        <UsersListBig
          users={subscribers}
          showSearch
          withoutTabs
          isLoading={isFetching && pageDataOwners.community === undefined}
          isError={isError}
        />
      </div>
    </PageContainer>
  );
}

export default withRouter(CommunitySubscribers);
